import * as yup from 'yup';

export default yup.object().shape({
  name: yup.string().required('Por favor informe o nome.'),
  is_default: yup.bool().nullable(),
});
